import { BaseUrlsKey, MEETINGMANAGEMENT_URL } from "utils/constants";
import { ENDPOINTS } from "utils/endpoints";
import { http } from "utils/http";

import { ENDPOINTSMEETINGSMANAGEMENT } from "utils/endpoints";
import { SignatureBaseUrl } from "./SignatureBaseUrl";



export const getDefaultSignature = (async (personId ) => await http({
    url: ENDPOINTS.BaseInformation.PersonSignature.load,
    method: "get",
    params:{
        personId :personId ,
       
    }
}).then((res) => {

    return res
}).catch((err) => {
 
    return Promise.reject( err);
})

)


export const  getPersonSignatureIdApi =( async ( Id ) =>  await http({
    url: ENDPOINTS.BaseInformation.PersonSignature.list,
    method: "get",
    params:{
        personId:Id
    }

})
.then((respons) => { 
   return respons.data

}).catch((err) => {
    return Promise.reject( err);
})

)

export const getSignature = (async ( referenceId ,parentFrom,jobId ) => await http({
    baseURL:SignatureBaseUrl[parentFrom]?.baseUrl ?SignatureBaseUrl[parentFrom]?.baseUrl:undefined,
    url:SignatureBaseUrl[parentFrom]?.endpoint.load ?SignatureBaseUrl[parentFrom]?.endpoint.load: ENDPOINTS.cartable.signature.load,
    method: "get",
    params:{
        referenceId : referenceId,
        SourceData:parentFrom,
        JobId:jobId
    }
}).then((res) => {

    return res.data
}).catch((err) => {
 
    return Promise.reject( err);
})

)
export const getMeetingSignature = ( ( MeetingId ,PositionId ) =>  http({
    baseURL:MEETINGMANAGEMENT_URL , 
    url: ENDPOINTSMEETINGSMANAGEMENT.MeetingsApis.Meetings.Signature,
    method: "get",
    params:{
        MeetingId:MeetingId,
        PositionId : PositionId
    }
}).then((res) => {

    return res.data
}).catch((err) => {
 
    return Promise.reject( err);
})

)
export const getSignatureHistory = (async ( referenceId ,parentFrom ,jobId ) => await http({
    baseURL:SignatureBaseUrl[parentFrom]?.baseUrl ?SignatureBaseUrl[parentFrom]?.baseUrl:undefined,
    url:SignatureBaseUrl[parentFrom]?.endpoint.browse ?SignatureBaseUrl[parentFrom]?.endpoint.browse :ENDPOINTS.cartable.signature.browse,
    method: "get",
    params:{
        referenceId : referenceId,
        SourceData:parentFrom,
        JobId:jobId
    }
}).then((res) => {

    return res.data
}).catch((err) => {
 
    return Promise.reject( err);
})

)
export const sendSignature = (async (baseUrlKey  ,data , method ,referenceId,ParentForm ,JobId) => await http({
    baseURL:SignatureBaseUrl[ParentForm]?.baseUrl ?SignatureBaseUrl[ParentForm]?.baseUrl  :undefined,
    url:SignatureBaseUrl[ParentForm]?.endpoint.browse ?SignatureBaseUrl[ParentForm]?.endpoint.browse: ENDPOINTS.cartable.signature.browse,
     method: method,
     params:{
        ReferenceId:referenceId,
        JobId:JobId,
        SourceData:ParentForm
     },
    data:data
}).then((res) => {

    return res
}).catch((err) => {
 
    return Promise.reject( err);
})

)
